/* RESPONSIBLE TEAM: team-frontend-tech */
import { computed } from '@ember/object';
import Predicate from 'predicates/models/predicate';
export default Predicate.extend({
  isEditable: true,
  isAnonymousType: true,
  genericType: 'anonymous',
  defaultComparison: 'true',
  getDefaultValue() {
    return null;
  },
  userType: computed('comparison', function () {
    if (this.comparison === 'false') {
      return 'user';
    } else if (this.comparison === 'true') {
      return 'lead';
    }
    throw new Error('not a valid user type');
  })
});